import type { FeeRule } from "../types.js";

/** Fee for a trade of `amount` yen under `rule`. */
export function feeFor(rule: FeeRule, amount: number): number {
  switch (rule.type) {
    case "zero":
      return 0;
    case "flat":
      return rule.amount;
    case "table": {
      for (const row of rule.table) {
        if (amount <= row.upTo) return row.fee;
      }
      return rule.above;
    }
  }
}
